import axios from "axios";
import { BASE_URL } from "../assets/constants";


export async function apply(formData) {
    try {
        const response = await axios.post(`${BASE_URL}/api/v1/application/android`, formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
            });
        return response;
    } catch (e) {
        return { error: true, message: e.response?.data?.message };
    }
}